<template>
	<div>
		<b-form-datepicker
			:id="fieldInfo.id"
			v-model="proxyValue"
			:readonly="!active"
			:placeholder="fieldInfo.placeholder"
			:state="state"
			:min="minDate"
		></b-form-datepicker>

		<b-form-invalid-feedback :id="`${name}-feedback`" :state="state">
			{{ errors[name] }}
		</b-form-invalid-feedback>
	</div>
</template>

<script>
export default {
	props: {
		fieldInfo: {
			type: Object
		},
		value: {
			type: String
		},
		errors: {
			type: Object
		},
		isActive: {
			type: [Boolean, Function],
			required: true
		},
		name: {
			type: String
		},
		state: {
			type: Boolean
		}
	},
	data() {
		return { active: true };
	},
	computed: {
		proxyValue: {
			get() {
				return this.value;
			},
			set(newValue) {
				this.$emit("input", newValue);
				this.$emit("change", this.fieldInfo.name);
			}
		},
		minDate: function () {
			return this.fieldInfo.minDate ? this.fieldInfo.minDate : new Date(0);
		}
	},
	beforeMount() {
		this.active = typeof this.isActive == "function" ? this.isActive(null) : this.isActive;
	}
};
</script>
